import { render, staticRenderFns } from "./DemoFormForTesting.vue?vue&type=template&id=f946cfe6"
import script from "./DemoFormForTesting.vue?vue&type=script&lang=js"
export * from "./DemoFormForTesting.vue?vue&type=script&lang=js"
import style0 from "./DemoFormForTesting.vue?vue&type=style&index=0&id=f946cfe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports